import { render } from "./MiLoader.vue?vue&type=template&id=0e7e95b8&scoped=true"
import script from "./MiLoader.vue?vue&type=script&lang=js"
export * from "./MiLoader.vue?vue&type=script&lang=js"

import "./MiLoader.vue?vue&type=style&index=0&id=0e7e95b8&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7e95b8"]])

export default __exports__